import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Po from './Po';
import Do from './Do';
import Ts from './Ts';
import Mobilfree from './Mobilfree';
import Bk from './Bk';
import Ppo from './Ppo';
import Hk from './Hk';
import Sj from './Sj';
import LapHk from './LapHk';
import LapSJ from './LapSJ';
import LapKM from './LapKM';
import LapDaily from './LapDaily';
import LastPosition from './LastPosition';
import LapMG from './LapMG';
import LapJBM from './LapJBM';
import LapMastergaji from './LapMastergaji';
import MasterInvoice from './MasterInvoice';
import LapKinerja from './LapKinerja';
import AiPenjualan from './AiPenjualan';

function Dashboard() {
  const location = useLocation();
  const navigate = useNavigate();
  const tusername = location.state?.tusername;

  const schema = localStorage.getItem('schema');

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [activeSection, setActiveSection] = useState('');
  const [activeMenu, setActiveMenu] = useState('');
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const [access, setAccess] = useState({
    is_admin: false,
    po: false,
    do: false,
    ts: false,
    ppo: false,
    sj: false,
    mobilfree: false,
    lap_hk: false,
    lap_sj: false,
    lastposition: false,
    lap_daily: false,
    lap_mg: false,
    lap_jbm: false,
    lap_km: false,
    mi: false,
    bk: false,
    lap_kinerja: false,
    hk: false,
  });

  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (!isLoggedIn) navigate('/');

    setAccess({
      is_admin: localStorage.getItem('is_admin') !== 'F',
      po: localStorage.getItem('po_access') !== 'F',
      do: localStorage.getItem('do_access') !== 'F',
      ts: localStorage.getItem('ts_access') !== 'F',
      ppo: localStorage.getItem('ppo_access') !== 'F',
      sj: localStorage.getItem('sj_access') !== 'F',
      mobilfree: localStorage.getItem('mobilfree_access') !== 'F',
      hk: localStorage.getItem('hk_access') !== 'F',
      lap_hk: localStorage.getItem('lap_hk_access') !== 'F',
      lap_sj: localStorage.getItem('lap_sj_access') !== 'F',
      lap_daily: localStorage.getItem('lap_daily') !== 'F',
      lap_mg: localStorage.getItem('lap_mg_access') !== 'F',
      lap_jbm: localStorage.getItem('lap_jbm_access') !== 'F',
      lastposition: localStorage.getItem('lastposition_access') !== 'F',
      lap_km: localStorage.getItem('lap_km_access') !== 'F',
      mi: localStorage.getItem('mi_access') !== 'F',
      bk: localStorage.getItem('bk_access') !== 'F',
      lap_kinerja: localStorage.getItem('lap_kinerja_access') !== 'F',
    });
  }, [navigate]);

  useEffect(() => {
    const handleBeforeUnload = () => localStorage.removeItem('isLoggedIn');
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setShowMobileMenu(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    navigate('/');
  };

  const toggleMenu = (menu) => {
    setActiveMenu(activeMenu === menu ? '' : menu);
  };

  const handleSectionSelect = (section) => {
    setActiveSection(section);
    setActiveMenu('');
    setShowMobileMenu(false);
  };

  const renderContent = () => {
    if (activeSection === 'Po') return <Po />;
    if (activeSection === 'Do') return <Do />;
    if (activeSection === 'Ts') return <Ts />;
    if (activeSection === 'Sj') return <Sj />;
    if (activeSection === 'Mobilfree') return <Mobilfree />;
    if (activeSection === 'Ppo') return <Ppo />;
    if (activeSection === 'Bk') return <Bk />;
    if (activeSection === 'Hk') return <Hk />;
    if (activeSection === 'LapHk') return <LapHk />;
    if (activeSection === 'LapSJ') return <LapSJ />;
    if (activeSection === 'LapMG') return <LapMG />;
    if (activeSection === 'LapJBM') return <LapJBM />;
    if (activeSection === 'LapDaily') return <LapDaily />;
    if (activeSection === 'LastPosition') return <LastPosition />;
    if (activeSection === 'LapMastergaji') return <LapMastergaji />;
    if (activeSection === 'LapKM') return <LapKM />;
    if (activeSection === 'MasterInvoice') return <MasterInvoice />;
    if (activeSection === 'LapKinerja') return <LapKinerja />;
    if (activeSection === 'AiPenjualan') return <AiPenjualan />;

    return (
      <div className="welcome-card">
        <h2>Selamat Datang, {tusername}</h2>
        <p>Server: {schema?.toUpperCase() || '-'}</p>
      </div>
    );
  };

  const MenuContent = () => (
    <>
      <div className="top-menu-group">
        <button
          className={`top-menu-btn ${activeMenu === 'master' ? 'active' : ''}`}
          onClick={() => toggleMenu('master')}
        >
          Master <span>▼</span>
        </button>

        {activeMenu === 'master' && (
          <div className="top-dropdown">
            <div
              className={`top-dropdown-item ${!access.ts ? 'disabled' : ''}`}
              onClick={() => {
                if (access.ts) handleSectionSelect('LapMastergaji');
              }}
            >
              Gaji
            </div>

            <div
              className={`top-dropdown-item ${!access.mi ? 'disabled' : ''}`}
              onClick={() => {
                if (access.mi) handleSectionSelect('MasterInvoice');
              }}
            >
              Invoice
            </div>
          </div>
        )}
      </div>

      <div className="top-menu-group">
        <button
          className={`top-menu-btn ${activeMenu === 'operasional' ? 'active' : ''}`}
          onClick={() => toggleMenu('operasional')}
        >
          Operasional <span>▼</span>
        </button>

        {activeMenu === 'operasional' && (
          <div className="top-dropdown">
            <div
              className={`top-dropdown-item ${!access.po ? 'disabled' : ''}`}
              onClick={() => {
                if (access.po) handleSectionSelect('Po');
              }}
            >
              PO
            </div>

            <div
              className={`top-dropdown-item ${!access.do ? 'disabled' : ''}`}
              onClick={() => {
                if (access.do) handleSectionSelect('Do');
              }}
            >
              DO
            </div>

            <div
              className={`top-dropdown-item ${!access.sj ? 'disabled' : ''}`}
              onClick={() => {
                if (access.sj) handleSectionSelect('Sj');
              }}
            >
              SJ
            </div>            

            <div
              className={`top-dropdown-item ${!access.ts ? 'disabled' : ''}`}
              onClick={() => {
                if (access.ts) handleSectionSelect('Ts');
              }}
            >
              TS
            </div>

            <div
              className={`top-dropdown-item ${!access.mobilfree ? 'disabled' : ''}`}
              onClick={() => {
                if (access.mobilfree) handleSectionSelect('Mobilfree');
              }}
            >
              Mobil Free
            </div>

            <div
              className={`top-dropdown-item ${!access.ppo ? 'disabled' : ''}`}
              onClick={() => {
                if (access.ppo) handleSectionSelect('Ppo');
              }}
            >
              PPO
            </div>            

            <div
              className={`top-dropdown-item ${!access.bk ? 'disabled' : ''}`}
              onClick={() => {
                if (access.bk) handleSectionSelect('Bk');
              }}
            >
              BK
            </div>

            <div
              className={`top-dropdown-item ${!access.hk ? 'disabled' : ''}`}
              onClick={() => {
                if (access.hk) handleSectionSelect('Hk');
              }}
            >
              HK
            </div>
          </div>
        )}
      </div>

      <div className="top-menu-group">
        <button
          className={`top-menu-btn ${activeMenu === 'laporan' ? 'active' : ''}`}
          onClick={() => toggleMenu('laporan')}
        >
          Laporan <span>▼</span>
        </button>

        {activeMenu === 'laporan' && (
          <div className="top-dropdown">
            <div
              className={`top-dropdown-item ${!access.lap_hk ? 'disabled' : ''}`}
              onClick={() => {
                if (access.lap_hk) handleSectionSelect('LapHk');
              }}
            >
              HK
            </div>

            <div
              className={`top-dropdown-item ${!access.lap_sj ? 'disabled' : ''}`}
              onClick={() => {
                if (access.lap_sj) handleSectionSelect('LapSJ');
              }}
            >
              SJ
            </div>

            <div
              className={`top-dropdown-item ${!access.lap_mg ? 'disabled' : ''}`}
              onClick={() => {
                if (access.lap_mg) handleSectionSelect('LapMG');
              }}
            >
              MG
            </div>

            <div
              className={`top-dropdown-item ${!access.lap_jbm ? 'disabled' : ''}`}
              onClick={() => {
                if (access.lap_jbm) handleSectionSelect('LapJBM');
              }}
            >
              JBM
            </div>

            <div
              className={`top-dropdown-item ${!access.lap_km ? 'disabled' : ''}`}
              onClick={() => {
                if (access.lap_km) handleSectionSelect('LapKM');
              }}
            >
              KM
            </div>

            <div
              className={`top-dropdown-item ${!access.lap_kinerja ? 'disabled' : ''}`}
              onClick={() => {
                if (access.lap_kinerja) handleSectionSelect('LapKinerja');
              }}
            >
              Kinerja
            </div>

            <div
              className={`top-dropdown-item ${!access.lap_daily ? 'disabled' : ''}`}
              onClick={() => {
                if (access.lap_daily) handleSectionSelect('LapDaily');
              }}
            >
              Harian
            </div>

            <div
              className={`top-dropdown-item ${!access.is_admin ? 'disabled' : ''}`}
              onClick={() => {
                if (access.is_admin) handleSectionSelect('AiPenjualan');
              }}
            >
              Analisa
            </div>

            <div
              className={`top-dropdown-item ${!access.lastposition ? 'disabled' : ''}`}
              onClick={() => {
                if (access.lastposition) handleSectionSelect('LastPosition');
              }}
            >
              GPS
            </div>
          </div>
        )}
      </div>
    </>
  );

  return (
    <div className="dashboard-wrapper-top">
      <style>{`
        * {
          box-sizing: border-box;
        }

        .dashboard-wrapper-top {
          width: 100%;
          min-height: 100vh;
          background: #f4f6f9;
          display: flex;
          flex-direction: column;
          font-family: Arial, sans-serif;
        }

        .top-navbar {
          height: 64px;
          background: #1e293b;
          color: white;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 20px;
          position: sticky;
          top: 0;
          z-index: 1000;
          box-shadow: 0 2px 10px rgba(0,0,0,0.15);
        }

        .top-left {
          display: flex;
          align-items: center;
          gap: 12px;
          min-width: 160px;
        }

        .schema-title {
          font-size: 20px;
          font-weight: bold;
          letter-spacing: 0.5px;
        }

        .top-menu {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .top-menu-group {
          position: relative;
        }

        .top-menu-btn {
          background: transparent;
          border: none;
          color: white;
          font-size: 15px;
          padding: 12px 14px;
          border-radius: 8px;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .top-menu-btn:hover,
        .top-menu-btn.active {
          background: rgba(255,255,255,0.14);
        }

        .top-dropdown {
          position: absolute;
          top: 48px;
          left: 0;
          min-width: 210px;
          background: white;
          color: #1f2937;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 8px 24px rgba(0,0,0,0.18);
          z-index: 2000;
          padding: 6px 0;
        }

        .top-dropdown-item {
          padding: 12px 16px;
          cursor: pointer;
          font-size: 14px;
          white-space: nowrap;
        }

        .top-dropdown-item:hover {
          background: #f1f5f9;
        }

        .top-dropdown-item.disabled {
          color: #aaa;
          cursor: not-allowed;
          background: #f8f8f8;
        }

        .top-right {
          min-width: 120px;
          display: flex;
          justify-content: flex-end;
        }

        .logout-btn {
          background: #ef4444;
          color: white;
          border: none;
          padding: 10px 16px;
          border-radius: 8px;
          cursor: pointer;
          font-weight: bold;
        }

        .logout-btn:hover {
          background: #dc2626;
        }

        .main-content-top {
          flex: 1;
          width: 100%;
          padding: 20px;
          overflow: auto;
        }

        .welcome-card {
          background: white;
          border-radius: 14px;
          padding: 30px;
          box-shadow: 0 4px 18px rgba(0,0,0,0.08);
        }

        .welcome-card h2 {
          margin-top: 0;
          color: #1e293b;
        }

        .welcome-card p {
          color: #475569;
          font-size: 16px;
        }

        .hamburger-btn {
          display: none;
          background: transparent;
          border: none;
          color: white;
          font-size: 28px;
          cursor: pointer;
        }

        .mobile-menu-panel {
          display: none;
        }

        @media (max-width: 768px) {
          .top-navbar {
            height: 60px;
            padding: 0 14px;
          }

          .hamburger-btn {
            display: block;
          }

          .schema-title {
            font-size: 18px;
          }

          .top-menu {
            display: none;
          }

          .top-right {
            display: none;
          }

          .mobile-menu-panel {
            display: block;
            background: #1e293b;
            color: white;
            padding: 10px;
            position: sticky;
            top: 60px;
            z-index: 999;
            box-shadow: 0 4px 12px rgba(0,0,0,0.2);
          }

          .mobile-menu-panel .top-menu-group {
            width: 100%;
          }

          .mobile-menu-panel .top-menu-btn {
            width: 100%;
            justify-content: space-between;
            padding: 14px;
            border-radius: 8px;
          }

          .mobile-menu-panel .top-dropdown {
            position: static;
            width: 100%;
            margin-bottom: 8px;
            box-shadow: none;
            border-radius: 8px;
          }

          .main-content-top {
            padding: 12px;
          }

          .welcome-card {
            padding: 20px;
          }
        }
      `}</style>

      <nav className="top-navbar">
        <div className="top-left">
          <button
            className="hamburger-btn"
            onClick={() => setShowMobileMenu(!showMobileMenu)}
          >
            {showMobileMenu ? '✕' : '☰'}
          </button>

          <div className="schema-title">
            {schema?.toUpperCase() || '-'}
          </div>
        </div>

        <div className="top-menu">
          <MenuContent />
        </div>

        <div className="top-right">
          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </nav>

      {isMobile && showMobileMenu && (
        <div className="mobile-menu-panel">
          <MenuContent />

          <button
            className="logout-btn"
            onClick={handleLogout}
            style={{ width: '100%', marginTop: 10 }}
          >
            Logout
          </button>
        </div>
      )}

      <main className="main-content-top">
        {renderContent()}
      </main>
    </div>
  );
}

export default Dashboard;